export default __webpack_public_path__ + "static/carousel-1-maurizio-633c655991bbc7878b0440b2631667d2.png";